var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCsvExport = function SvgCsvExport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-CSV",
    transform: "translate(-983 -490)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 18,
    height: 18,
    transform: "translate(983 490)",
    fill: "#3b3b3b",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "download_FILL0_wght400_GRAD-25_opsz20",
    d: "M208.439-795.535a.706.706,0,0,1-.3-.064.825.825,0,0,1-.245-.168l-3.175-3.175a.72.72,0,0,1-.226-.544.767.767,0,0,1,.238-.546.754.754,0,0,1,.55-.226.761.761,0,0,1,.539.238l1.843,1.866v-7.069a.75.75,0,0,1,.227-.548.741.741,0,0,1,.545-.228.757.757,0,0,1,.55.228.742.742,0,0,1,.232.548v7.069l1.866-1.866a.7.7,0,0,1,.535-.226.8.8,0,0,1,.554.238.724.724,0,0,1,.226.545.767.767,0,0,1-.238.545l-3.175,3.152a.961.961,0,0,1-.254.168A.706.706,0,0,1,208.439-795.535ZM203.546-792a1.485,1.485,0,0,1-1.094-.455,1.5,1.5,0,0,1-.452-1.1v-.834a.75.75,0,0,1,.227-.548.74.74,0,0,1,.545-.228.756.756,0,0,1,.55.228.742.742,0,0,1,.232.548v.834h9.781v-.834a.75.75,0,0,1,.227-.548.74.74,0,0,1,.545-.228.756.756,0,0,1,.55.228.742.742,0,0,1,.232.548v.834a1.5,1.5,0,0,1-.456,1.1,1.5,1.5,0,0,1-1.1.455Z",
    transform: "translate(783.556 1298)",
    fill: "#3953fb"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCsvExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/csvExport.5d0b2a84.svg";
export { ForwardRef as ReactComponent };